module.exports = __webpack_public_path__ + "img/onnuriVoucher.793b2dd1.png";